import { Home } from "../pages/home";
import { About } from "../pages/about";
import { Portfolio } from "../pages/portfolio";
import { ContactUs } from "../pages/contact";

const routesData = [{
    path: "/",
    desc: "Home",
    component: Home,
},
{
    path: "/portfolio",
    desc: "Portfolio",
    component: Portfolio,
},
{
    path: "/about",
    desc: "About",
    component: About,
},
{
    path: "/contact",
    desc: "Contact",
    component: ContactUs,
},
];

export {
    routesData,
};